module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAmklEQVRYhe3QSw3DMBBF0QvBEAzBEMqwEAKhEAIhEAyhENpFM5JV5WMnM3EW87YZ+VwFfD6f70ZLwKOn8wQ+xhEJeAPD2sEwHyRjPGwdjgYR1bhFhOBjLa4ZIfjUimtEJCCfwWXTgYiohTM/0BKhiv9H5J1HTfDaCPlugu9FlHi0wpewcDW+FPHi90cuw8uI3AuXxZ64z+dT2RcJ8jKrfD2BKAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/community/godown.png
// module id = 1Wsk
// module chunks = 1